import type { ChangeSubtaskAttachment } from '../../types/changes';
import { linkifyRichTextHtml, sanitizeRichTextHtml } from '../../utils/richTextSanitizer';

export const FILE_ONLY_REPLY = 'Anexo enviado.';
export const CONCLUDED_REPLY = 'Subtarefa concluída.';
export const SUBTASK_REPLY_LABEL =
  'Escreva na conversa (grupo, pessoa designada ou quem abriu a mudança)';

export function isBlankRichText(html: string): boolean {
  return !html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\u00a0/g, ' ')
    .trim();
}

export function prepareSubtaskReplyHtml(html: string): string {
  return linkifyRichTextHtml(sanitizeRichTextHtml(html));
}

export function formatReplyWhen(value?: string | null): string {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('pt-BR');
}

export function splitSubtaskAttachments(
  attachments: ChangeSubtaskAttachment[],
  replies: Array<{ id: number; created_at: string }>,
): { byReplyId: Record<number, ChangeSubtaskAttachment[]>; leftover: ChangeSubtaskAttachment[] } {
  const byReplyId: Record<number, ChangeSubtaskAttachment[]> = {};
  replies.forEach((reply) => {
    byReplyId[reply.id] = [];
  });
  const leftover: ChangeSubtaskAttachment[] = [];
  const sorted = [...replies].sort(
    (left, right) => Date.parse(left.created_at) - Date.parse(right.created_at),
  );

  attachments.forEach((file) => {
    if (file.comment_id && byReplyId[file.comment_id]) {
      byReplyId[file.comment_id].push(file);
      return;
    }
    const uploadedAt = file.uploaded_at ? Date.parse(file.uploaded_at) : NaN;
    let chosenId: number | null = null;
    if (!Number.isNaN(uploadedAt)) {
      sorted.forEach((reply) => {
        const createdAt = Date.parse(reply.created_at);
        if (!Number.isNaN(createdAt) && createdAt <= uploadedAt) {
          chosenId = reply.id;
        }
      });
    }
    if (chosenId != null) {
      byReplyId[chosenId].push(file);
      return;
    }
    leftover.push(file);
  });

  return { byReplyId, leftover };
}
